import React from "react";
import { object, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism4 from "../../organisms/organism-4";
import HoroscopeSingleStory from "./horoscope-single-story";

import { getSlug } from "../../utils";

import "./videos.m.css";

const VideosRow = ({ collection, sections, config, horoscopeCollection = {} }) => {
  const slug = getSlug(collection, sections);
  return (
    <div styleName="wrapper">
      <Organism4
        collection={collection}
        headerType={10}
        headlineLimit={60}
        href={slug}
        text={config["page-type"] === "home-page" ? "Videos" : collection.name}
      />
      <div styleName="second-group">
        <HoroscopeSingleStory collection={horoscopeCollection} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

VideosRow.propTypes = {
  collection: object,
  sections: array,
  config: object,
  horoscopeCollection: object
};

export default connect(
  mapStateToProps,
  null
)(VideosRow);
